export enum userActionEvents {
  BOT_LOADED_FIRST = 'bot_loaded_first',
  BOT_LOADED_NTH = 'bot_loaded_nth',
  MENU_OPEN = 'menu_open',
  EF_REVIEW = 'ef_review',
  EF_REVIEW_CANCEL = 'ef_review_cancel',
  EF_REVIEW_PROCEED = 'ef_review_proceed',
}
